import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDisplayState } from '../interfaces/display-state.interface';

const displayState: IDisplayState = {
  preloader: true,
  sendLoader: false,
  expert: false,
  buttonBack: false,
  label: true,
  flyingButton: true,
  progressBar: false,
  error: false,
  serverError: true,
  bonuses: true,
  infoBlock: false,
  whatsAppForm: true,
  popupWindow: false,
};

export const displaySlice = createSlice({
  name: "display",
  initialState: displayState,
  reducers: {
    displayByProvider: (state, action: PayloadAction<Partial<IDisplayState>>) => {
      return { ...state, ...action.payload };
    },
  
    displayPreloader: (state, action: PayloadAction<boolean>) => {
      state.preloader = action.payload;
    },
  
    displaySendLoader: (state, action: PayloadAction<boolean>) => {
      state.sendLoader = action.payload;
    },
  
    displayExpert: (state, action: PayloadAction<boolean>) => {
      state.expert = action.payload;
    },
  
    displayButtonBack: (state, action: PayloadAction<boolean>) => {
      state.buttonBack = action.payload;
    },
  
    displayLabel: (state, action: PayloadAction<boolean>) => {
      state.label = action.payload;
    },
  
    displayFlyingButton: (state, action: PayloadAction<boolean>) => {
      state.flyingButton = action.payload;
    },
  
    displayProgressBar: (state, action: PayloadAction<boolean>) => {
      state.progressBar = action.payload;
    },
  
    displayError: (state, action: PayloadAction<boolean>) => {
      state.error = action.payload;
    },
  
    displayServerError: (state, action: PayloadAction<boolean>) => {
      state.serverError = action.payload;
    },
  
    displayBonuses: (state, action: PayloadAction<boolean>) => {
      state.bonuses = action.payload;
    },
  
    displayInfoBlock: (state, action: PayloadAction<boolean>) => {
      state.infoBlock = action.payload;
    },
  
    displayWhatsAppForm: (state, action: PayloadAction<boolean>) => {
      state.whatsAppForm = action.payload;
    },
  
    displayPopupWindow: (state, action: PayloadAction<boolean>) => {
      state.popupWindow = action.payload;
    }
  }
});

export const { 
  displayBonuses,
  displayButtonBack,
  displayByProvider,
  displayError,
  displayExpert,
  displayFlyingButton,
  displayInfoBlock,
  displayLabel,
  displayPopupWindow,
  displayPreloader,
  displayProgressBar,
  displaySendLoader,
  displayServerError, 
  displayWhatsAppForm 
} = displaySlice.actions;

export default displaySlice.reducer;